(() => {
  if (window.customElements.get('cart-wishlist-move')) return;

  var APP_BUTTON_TAG = 'xb-wishlist-button-collection';
  var COMMIT_TIMEOUT = 6000;
  var REMOVE_WAIT_MS = 5000;
  var REMOVE_SETTLE_MS = 350;
  var RECENT_REMOVE_MS = 8000;
  var CART_ADD_REMOVE_DELAY = 1200;
  var LS_DATA = 'xb_wishlist_data';
  var LS_KEYS = 'xb_wishlist_all_product_keys';
  var LS_LIST = 'default';
  var LS_SESSION = 'sessionId';
  var ADD_HYDRATE_MS = 1500;

  /* 与 product-wishlist.js 保持同一套判定：组件内出现 remove 态即已收藏 */
  var isWishlisted = function (appButton) {
    if (!(appButton instanceof HTMLElement)) return false;
    var root = appButton.shadowRoot || appButton;
    if (root.querySelector('.xb-wishlist-button-collection__remove')) return true;
    if (root.querySelector('.xb-wishlist-button-collection__add')) return false;
    return appButton.classList.contains('is-active') || appButton.hasAttribute('active');
  };

  var parseJson = function (raw, fallback) {
    try {
      var value = JSON.parse(raw);
      return value == null ? fallback : value;
    } catch (error) {
      return fallback;
    }
  };

  var hasLocalWishlistStore = function () {
    try {
      return localStorage.getItem(LS_DATA) != null || localStorage.getItem(LS_KEYS) != null;
    } catch (error) {
      return false;
    }
  };

  var parseIdList = function (raw) {
    return String(raw || '')
      .split(',')
      .map(function (id) {
        return String(id).trim();
      })
      .filter(Boolean);
  };

  var skcKey = function (productId, variantId) {
    var pid = String(productId || '');
    var vid = String(variantId || '');
    return vid ? pid + ':' + vid : pid;
  };

  /* 应用写入的两份本地数据：xb_wishlist_data 带 variantId，keys 是 id:variantId。按 SKC 收变体 id。 */
  var readWishlistedVariantIds = function () {
    var ids = new Set();
    try {
      var data = parseJson(localStorage.getItem(LS_DATA), []);
      if (Array.isArray(data)) {
        data.forEach(function (item) {
          var id = String((item && (item.variantId || item.variant_id)) || '').trim();
          if (id) ids.add(id);
        });
      }

      if (!ids.size) {
        var keys = parseJson(localStorage.getItem(LS_KEYS), {});
        if (keys && typeof keys === 'object') {
          Object.keys(keys).forEach(function (listId) {
            (keys[listId] || []).forEach(function (key) {
              var id = String(key).split(':')[1] || '';
              if (id) ids.add(id);
            });
          });
        }
      }
    } catch (error) {
      return ids;
    }
    return ids;
  };

  var getSkcVariantIds = function (el) {
    var ids = parseIdList(el && el.getAttribute('data-skc-variant-ids'));
    var variantId = el && el.getAttribute('data-variant-id');
    if (variantId && ids.indexOf(variantId) === -1) ids.push(variantId);
    return ids;
  };

  var isSkcInStore = function (el) {
    var wishlisted = readWishlistedVariantIds();
    return getSkcVariantIds(el).some(function (id) {
      return wishlisted.has(id);
    });
  };

  var isSkcWishlisted = function (el, appButton) {
    if (hasLocalWishlistStore()) return isSkcInStore(el);
    return appButton ? isWishlisted(appButton) : false;
  };

  var shopRoot = function () {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  };

  var xbMeta = function () {
    return window.xb_wishlist || {};
  };

  var ensureSessionId = function () {
    try {
      var id = localStorage.getItem(LS_SESSION);
      if (id) return id;
      id =
        (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
        'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (ch) {
          var rand = (Math.random() * 16) | 0;
          return (ch === 'x' ? rand : (rand & 3) | 8).toString(16);
        });
      localStorage.setItem(LS_SESSION, id);
      return id;
    } catch (error) {
      return '';
    }
  };

  /* 应用 addWishlistItem / addKey 的本地写法：data 带 variant，keys 是 default 列表里的 id:variantId */
  var writeLocalWishlistItem = function (item) {
    var productId = String((item && item.productId) || '');
    var variantId = String((item && item.variantId) || '');
    if (!productId || !variantId) return false;

    var shop = xbMeta().myShopify || (window.Shopify && window.Shopify.shop) || '';
    var row = {
      productId: productId,
      variantId: variantId,
      title: (item && item.title) || '',
      handle: (item && item.handle) || '',
      myShopify: shop,
      price: Number(item && item.price) || 0,
      addedAt: new Date().toISOString(),
    };

    var data = parseJson(localStorage.getItem(LS_DATA), []);
    if (!Array.isArray(data)) data = [];
    var exists = data.some(function (entry) {
      return (
        String((entry && (entry.productId || entry.product_id)) || '') === productId &&
        String((entry && (entry.variantId || entry.variant_id)) || '') === variantId
      );
    });
    if (!exists) {
      data.unshift(row);
      data.sort(function (left, right) {
        var timeA = left && left.addedAt ? Date.parse(left.addedAt) || 0 : 0;
        var timeB = right && right.addedAt ? Date.parse(right.addedAt) || 0 : 0;
        return timeB - timeA;
      });
      localStorage.setItem(LS_DATA, JSON.stringify(data));
    }

    var keys = parseJson(localStorage.getItem(LS_KEYS), {});
    if (!keys || typeof keys !== 'object') keys = {};
    var list = Array.isArray(keys[LS_LIST]) ? keys[LS_LIST].slice() : [];
    var key = skcKey(productId, variantId);
    if (list.indexOf(key) === -1) {
      list.push(key);
      keys[LS_LIST] = list;
      localStorage.setItem(LS_KEYS, JSON.stringify(keys));
    }
    return true;
  };

  var postWishlistAdd = function (item) {
    var meta = xbMeta();
    var root = shopRoot();
    var headers = { 'Content-Type': 'application/json' };
    var payload = {
      action: 'add',
      customerId: meta.customerId || '',
      productId: item.productId,
      shop: meta.myShopify || (window.Shopify && window.Shopify.shop) || '',
      title: item.title || '',
      variantId: item.variantId,
      sessionId: ensureSessionId(),
    };

    fetch(root + 'tools/xb-wishlist', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
    }).catch(function () {});

    fetch(root + 'tools/xb-wishlist/update-count', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ productId: item.productId, action: 'increment' }),
    }).catch(function () {});
  };

  /* 心愿页加购会先乐观移出，应用真正写入可能滞后。这段窗口里不能把「本地还在清单」当成已收藏。
     同步键按 SKC（productId:variantId），同款另一色互不影响。 */
  var wishlistSync = window.__tiemcoWishlistSync;
  if (!wishlistSync) wishlistSync = window.__tiemcoWishlistSync = {};
  wishlistSync.recentRemoves = wishlistSync.recentRemoves || new Map();
  wishlistSync.delayedRemoves = wishlistSync.delayedRemoves || new Map();
  wishlistSync.skcKey = skcKey;
  wishlistSync.markRecentRemove = function (productId, variantId) {
    var key = skcKey(productId, variantId);
    if (!key) return;
    this.recentRemoves.set(key, Date.now());
  };
  wishlistSync.wasRecentlyRemoved = function (productId, variantIds) {
    var ids = Array.isArray(variantIds) ? variantIds : [variantIds];
    var self = this;
    if (
      ids.some(function (id) {
        var t = self.recentRemoves.get(skcKey(productId, id));
        return !!t && Date.now() - t < RECENT_REMOVE_MS;
      })
    ) {
      return true;
    }
    var fallback = this.recentRemoves.get(String(productId || ''));
    return !!fallback && Date.now() - fallback < RECENT_REMOVE_MS;
  };
  wishlistSync.scheduleDelayedRemove = function (productId, fire, delay, variantId) {
    var key = skcKey(productId, variantId);
    if (!key || typeof fire !== 'function') return;
    var existing = this.delayedRemoves.get(key);
    if (existing) clearTimeout(existing);
    var self = this;
    var timer = setTimeout(function () {
      self.delayedRemoves.delete(key);
      fire();
    }, delay || CART_ADD_REMOVE_DELAY);
    this.delayedRemoves.set(key, timer);
  };
  wishlistSync.cancelDelayedRemove = function (productId, variantIds) {
    var ids = Array.isArray(variantIds) ? variantIds.slice() : [];
    if (!ids.length && variantIds) ids = [variantIds];
    var cancelled = false;
    var self = this;
    var keys = ids.map(function (id) {
      return skcKey(productId, id);
    });
    keys.push(String(productId || ''));
    keys.forEach(function (key) {
      var timer = self.delayedRemoves.get(key);
      if (!timer) return;
      clearTimeout(timer);
      self.delayedRemoves.delete(key);
      self.recentRemoves.delete(key);
      cancelled = true;
    });
    return cancelled;
  };

  var wasRecentlyRemoved = function (el) {
    return wishlistSync.wasRecentlyRemoved(el.getAttribute('data-product-id'), getSkcVariantIds(el));
  };

  /* 登录 / 协作弹层要停转圈，让用户点；toast 在抽屉外，不能据此关掉抽屉里的 loading */
  var XB_LOGIN_SELECTOR = '.xb-move-modal__overlay, .xb-move-modal__panel, .xb-collab-overlay';
  var XB_TOAST_SELECTOR = '.xb-wishlist-notification';
  var XB_POPUP_SELECTOR = XB_TOAST_SELECTOR + ', ' + XB_LOGIN_SELECTOR;

  var isVisibleOverlay = function (el) {
    if (!el || el.hidden || el.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (parseFloat(style.opacity) === 0) return false;
    return true;
  };

  var isSelectorOpen = function (selector) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (isVisibleOverlay(nodes[i])) return true;
    }
    return false;
  };

  var isXbLoginOpen = function () {
    return isSelectorOpen(XB_LOGIN_SELECTOR);
  };

  var isXbPopupOpen = function () {
    return isSelectorOpen(XB_POPUP_SELECTOR);
  };

  var isAddCommitted = function (el, appButton) {
    if (hasLocalWishlistStore()) return isSkcInStore(el);
    return appButton ? isWishlisted(appButton) : false;
  };

  /* 同页 localStorage.setItem 不会触发 storage；应用写 xb_wishlist_* 时主动通知 */
  var patchLocalWishlist = function () {
    if (window.__tiemcoWishlistStoragePatched) return;
    window.__tiemcoWishlistStoragePatched = true;

    var original = window.localStorage.setItem.bind(window.localStorage);
    window.localStorage.setItem = function (key, value) {
      var prev = window.localStorage.getItem(key);
      original(key, value);
      if (key && String(key).indexOf('xb_wishlist') === 0 && prev !== String(value)) {
        document.dispatchEvent(new CustomEvent('xb-wishlist:local-change'));
      }
    };
  };

  var CartWishlistMove = class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this.trigger = this.querySelector('[data-cart-wishlist-trigger]');
      this.appHost = this.querySelector('[data-cart-wishlist-app]');
      if (!this.trigger || !this.appHost) return;

      this.pending = false;
      this.addClicked = false;
      this.allowRemove = false;

      this.onClick = this.onClick.bind(this);
      this.trigger.addEventListener('click', this.onClick);

      this.watchAppButton();
    }

    disconnectedCallback() {
      this.clearTimers();
      if (this.appObserver) this.appObserver.disconnect();
      if (this.stateObserver) this.stateObserver.disconnect();
      if (this.shadowObserver) this.shadowObserver.disconnect();
    }

    getAppButton() {
      return this.appHost ? this.appHost.querySelector(APP_BUTTON_TAG) : null;
    }

    getProductId() {
      return this.getAttribute('data-product-id') || '';
    }

    getVariantId() {
      return this.getAttribute('data-variant-id') || '';
    }

    getSkcVariantIds() {
      return getSkcVariantIds(this);
    }

    /* 应用按钮异步注入，出现后再绑状态监听并做一次初始同步 */
    watchAppButton() {
      var self = this;
      var bind = function () {
        var button = self.getAppButton();
        if (!button || button.hasAttribute('data-cart-wishlist-watch')) {
          if (button) self.syncState();
          return;
        }
        button.setAttribute('data-cart-wishlist-watch', '');

        self.stateObserver = new MutationObserver(function () {
          self.syncState();
        });
        self.stateObserver.observe(button, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'active'],
        });

        if (button.shadowRoot) {
          self.shadowObserver = new MutationObserver(function () {
            self.syncState();
          });
          self.shadowObserver.observe(button.shadowRoot, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class'],
          });
        }

        self.syncState();
      };

      bind();
      this.appObserver = new MutationObserver(bind);
      this.appObserver.observe(this.appHost, { childList: true, subtree: true });

      if (window.customElements && window.customElements.whenDefined) {
        window.customElements.whenDefined(APP_BUTTON_TAG).then(bind).catch(function () {});
      }
    }

    /* 已收藏且不是刚从心愿单加购移出时，隐藏「移入」；pending 时认本地 SKC，不能只等 1px 隐藏按钮切 remove */
    syncState() {
      if (!this.trigger) return;
      if (this.pending) {
        if (this.addClicked && isAddCommitted(this, this.getAppButton())) this.onAddConfirmed();
        return;
      }
      this.trigger.hidden = isSkcWishlisted(this, this.getAppButton()) && !wasRecentlyRemoved(this);
    }

    /* 抽屉关着时应用不会更新隐藏按钮；重挂让它按当前心愿单重新 hydrate */
    remountAppButton() {
      if (!this.appHost) return;

      var current = this.getAppButton() || this.appHost.querySelector('[xb-handle]');
      var handle = current && current.getAttribute('xb-handle');
      if (!handle) return;
      var variant =
        (current && (current.getAttribute('variant') || current.getAttribute('xb-variant'))) || this.getVariantId();

      if (this.stateObserver) {
        this.stateObserver.disconnect();
        this.stateObserver = null;
      }
      if (this.shadowObserver) {
        this.shadowObserver.disconnect();
        this.shadowObserver = null;
      }

      var next = document.createElement(APP_BUTTON_TAG);
      next.setAttribute('xb-handle', handle);
      if (variant) next.setAttribute('variant', variant);
      this.appHost.replaceChildren(next);
    }

    /* 先按本地 SKC 校正显隐；应用按钮仍是 SPU 态时再重挂，避免点到过期的 remove */
    refreshFromStore() {
      this.syncState();
      if (this.pending || !hasLocalWishlistStore()) return;
      if (wasRecentlyRemoved(this)) return;
      if (isSkcInStore(this) !== isWishlisted(this.getAppButton())) this.remountAppButton();
    }

    showGlobalLoading() {
      if (isXbLoginOpen()) return;
      if (this.closest && this.closest('cart-drawer')) {
        if (typeof window.__showCartDrawerLoading === 'function') {
          window.__showCartDrawerLoading();
        }
        return;
      }
      if (this.closest && this.closest('[data-cart-page]')) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:overlay-loading:start', { bubbles: true }));
      }
    }

    hideGlobalLoading() {
      if (this.closest && this.closest('cart-drawer') && typeof window.__hideCartDrawerLoading === 'function') {
        window.__hideCartDrawerLoading(true);
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('theme:overlay-loading:end', { bubbles: true }));
    }

    /* 登录弹层出现就停转圈；toast 只表示加入成功，遮罩留到删行结束 */
    watchPopup() {
      if (this.popupObserver) return;
      var self = this;
      var release = function () {
        if (!self.pending || !isXbPopupOpen()) return;
        if (isXbLoginOpen()) self.hideGlobalLoading();
        if (self.addClicked && isAddCommitted(self, self.getAppButton())) {
          self.onAddConfirmed();
        }
      };
      this.popupObserver = new MutationObserver(release);
      this.popupObserver.observe(document.documentElement, { childList: true, subtree: true });
      release();
    }

    onClick(event) {
      /* 加入成功后主动放行：不拦截，让 line-item 的委托按 href 走原生删除 */
      if (this.allowRemove) {
        this.allowRemove = false;
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (this.pending) return;

      var appButton = this.getAppButton();
      if (!appButton) return;

      var productId = this.getProductId();
      /* 加购触发的延迟移出还没交给应用：取消它，这个 SKC 仍在心愿单，只删购物车行 */
      var cancelled = wishlistSync.cancelDelayedRemove(productId, this.getSkcVariantIds());

      if (cancelled) {
        this.notifyWishlistPage();
        this.removeLineItem();
        return;
      }

      /* 刚从心愿单加购移出，或本地已不在这个 SKC：必须再加入，不能当成「已收藏」直接删行 */
      if (wasRecentlyRemoved(this) || !isSkcWishlisted(this, appButton)) {
        this.pending = true;
        this.addClicked = false;
        this._settledAt = 0;
        this._remountedForAdd = false;
        this.trigger.setAttribute('aria-busy', 'true');
        this.trigger.classList.add('is-loading');
        this.showGlobalLoading();
        this.watchPopup();
        this.startAdd();
        return;
      }

      this.notifyWishlistPage();
      this.removeLineItem();
    }

    /* 等 in-flight 移出写入本地后再点 add；过期的 remove 按钮会把商品再移出一次 */
    startAdd() {
      var self = this;
      var started = Date.now();

      var tick = function () {
        if (!self.pending || !self.isConnected) return;

        var inStore = hasLocalWishlistStore() && isSkcInStore(self);
        var button = self.getAppButton();

        if (wasRecentlyRemoved(self) && inStore) {
          if (Date.now() - started < REMOVE_WAIT_MS) {
            self.prepareTimer = setTimeout(tick, 50);
            return;
          }
          /* 应用没把移出写完，当作这个 SKC 仍在心愿单，只同步页面后删行 */
          self.clearTimers();
          self.notifyWishlistPage();
          self.pending = false;
          self.addClicked = false;
          self.removeLineItem();
          return;
        }

        if (wasRecentlyRemoved(self) && !self._settledAt) self._settledAt = Date.now();
        if (self._settledAt && Date.now() - self._settledAt < REMOVE_SETTLE_MS) {
          self.prepareTimer = setTimeout(tick, 50);
          return;
        }

        /* 应用按钮可能因同款另一色仍是 remove：先重挂一次带 variant，仍是 remove 就改走加入接口 */
        if (isWishlisted(button) && !inStore) {
          if (!self._remountedForAdd) {
            self._remountedForAdd = true;
            self.remountAppButton();
            self.prepareTimer = setTimeout(tick, 80);
            return;
          }
          self.addCurrentSkcViaApi();
          return;
        }

        if (!self.clickAddButton(self.getAppButton())) {
          if (Date.now() - started < ADD_HYDRATE_MS) {
            self.prepareTimer = setTimeout(tick, 80);
            return;
          }
          /* 应用没 hydrate 出 add（或一直是 SPU remove）：按当前 variant 写入 */
          self.addCurrentSkcViaApi();
          return;
        }

        /* click() 里应用可能同步写出 toast / localStorage，确认后不要再挂 6s 超时 */
        if (isAddCommitted(self, self.getAppButton())) {
          self.onAddConfirmed();
          return;
        }
        if (isXbLoginOpen()) self.hideGlobalLoading();
        if (!self.pending) return;

        self.commitTimer = setTimeout(function () {
          self.resetPending();
        }, COMMIT_TIMEOUT);
      };

      tick();
    }

    clickAddButton(appButton) {
      if (!(appButton instanceof HTMLElement)) return false;
      var root = appButton.shadowRoot || appButton;
      var clickable =
        root.querySelector('.xb-wishlist-button-collection__add button') ||
        root.querySelector('.xb-wishlist-button-collection__add');
      if (!clickable) return false;
      this.addClicked = true;
      clickable.click();
      return true;
    }

    getLineTitle() {
      var line = this.closest('line-item, .cart-row');
      if (!line) return '';
      var el = line.querySelector('.line-item__info a.subheading, .line-item__info p.subheading, .cart-row__title');
      return (el && el.textContent && el.textContent.trim()) || '';
    }

    getAppHandle() {
      var current = this.getAppButton() || (this.appHost && this.appHost.querySelector('[xb-handle]'));
      return (current && current.getAttribute('xb-handle')) || '';
    }

    /* 应用按钮按 SPU 停在 remove 时，按当前 variant 写本地并 POST 加入接口，再删购物车行 */
    addCurrentSkcViaApi() {
      var productId = this.getProductId();
      var variantId = this.getVariantId();
      var item = {
        productId: productId,
        variantId: variantId,
        title: this.getAttribute('data-product-title') || this.getLineTitle(),
        handle: this.getAttribute('data-product-handle') || this.getAppHandle(),
        price: this.getAttribute('data-product-price') || 0,
      };

      if (!writeLocalWishlistItem(item)) {
        this.resetPending();
        return;
      }

      this.addClicked = true;
      postWishlistAdd(item);
      this.onAddConfirmed();
    }

    onAddConfirmed() {
      if (!this.pending || !this.addClicked) return;
      this.clearTimers();
      this.pending = false;
      this.addClicked = false;
      this.notifyWishlistPage();
      this.removeLineItem();
    }

    /* 心愿页只听应用事件和跨 tab 的 storage；同页移入既可能发不出事件，
       也可能被刚加购留下的 pendingRemovedIds 挡住。主动通知并带上商品 id。 */
    notifyWishlistPage() {
      var productId = this.getProductId();
      var variantId = this.getVariantId();
      var fire = function () {
        document.dispatchEvent(
          new CustomEvent('cart:move-to-wishlist', {
            bubbles: true,
            composed: true,
            detail: { productId: productId, variantId: variantId },
          })
        );
      };
      fire();
      /* 行删掉后本元素会被购物车重绘卸掉，延迟补一次不能绑在实例 timer 上 */
      setTimeout(fire, 400);
    }

    /* 复用 line-item 原生删除委托：设放行标志后触发链接点击，走 cart/change quantity=0。
       抽屉遮罩只盖面板，toast 在外面；这里要一直转到行删完。 */
    removeLineItem() {
      this.trigger.removeAttribute('aria-busy');
      this.trigger.classList.remove('is-loading');
      this.showGlobalLoading();
      this.allowRemove = true;
      this.trigger.click();
    }

    resetPending() {
      this.clearTimers();
      this.pending = false;
      this.addClicked = false;
      this.trigger.removeAttribute('aria-busy');
      this.trigger.classList.remove('is-loading');
      this.hideGlobalLoading();
      this.syncState();
    }

    clearTimers() {
      if (this.commitTimer) {
        clearTimeout(this.commitTimer);
        this.commitTimer = 0;
      }
      if (this.prepareTimer) {
        clearTimeout(this.prepareTimer);
        this.prepareTimer = 0;
      }
      if (this.popupObserver) {
        this.popupObserver.disconnect();
        this.popupObserver = null;
      }
    }
  };

  window.customElements.define('cart-wishlist-move', CartWishlistMove);

  var refreshMoves = function (root) {
    (root || document).querySelectorAll('cart-wishlist-move').forEach(function (el) {
      if (typeof el.refreshFromStore === 'function') el.refreshFromStore();
    });
  };

  var remountMoves = function (root) {
    (root || document).querySelectorAll('cart-wishlist-move').forEach(function (el) {
      if (typeof el.remountAppButton === 'function') el.remountAppButton();
      if (typeof el.syncState === 'function') el.syncState();
    });
  };

  patchLocalWishlist();

  /* dialog:before-show 不冒泡，必须捕获；此时抽屉已去掉 display:none，应用才能重新 hydrate */
  document.addEventListener(
    'dialog:before-show',
    function (event) {
      if (!(event.target instanceof HTMLElement) || event.target.id !== 'cart-drawer') return;
      remountMoves(event.target);
    },
    true
  );

  var bindDrawerOpen = function (drawer) {
    if (!(drawer instanceof HTMLElement) || drawer.hasAttribute('data-cart-wishlist-open-watch')) return;
    drawer.setAttribute('data-cart-wishlist-open-watch', '');
    new MutationObserver(function () {
      if (!drawer.hasAttribute('open')) return;
      drawer.querySelectorAll('cart-wishlist-move').forEach(function (el) {
        if (typeof el.syncState === 'function') el.syncState();
      });
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  };

  bindDrawerOpen(document.getElementById('cart-drawer'));
  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('cart-drawer').then(function () {
      bindDrawerOpen(document.getElementById('cart-drawer'));
    }).catch(function () {});
  }

  document.addEventListener('cart-drawer:refreshed', function (event) {
    var drawer = event.target instanceof HTMLElement ? event.target : document.getElementById('cart-drawer');
    refreshMoves(drawer);
  });

  document.addEventListener('xb-wishlist:pending-remove', function (event) {
    wishlistSync.markRecentRemove(
      event && event.detail && event.detail.productId,
      event && event.detail && event.detail.variantId
    );
    refreshMoves(document);
  });

  ['xb-wishlist:local-change', 'xb-wishlist:remove', 'xb-wishlist:update-state'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (name === 'xb-wishlist:remove') {
        wishlistSync.markRecentRemove(
          event && event.detail && event.detail.productId,
          event && event.detail && event.detail.variantId
        );
      }
      refreshMoves(document);
    });
  });
})();
